export class SoundNotification {
  constructor(readonly url: string) {}
}
